// src/components/SignUp.js

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import supabase from '../supabase';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState(''); // Example additional field
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async () => {
    if (!email || !password || !fullName) {
      setMessage('Please fill in all required fields.');
      return;
    }
  
    setLoading(true);
    setMessage('');
  
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: fullName, // This gets stored in raw_user_meta_data
          },
        },
      });
  
      if (error) {
        setMessage(`Error: ${error.message}`);
        console.error('Supabase SignUp Error:', error);
      } else if (!data) {
        setMessage('Sign-up failed. Please try again later.');
        console.error('No data returned from sign-up.');
      } else {
        setMessage('Sign-up successful! Please check your email to confirm.');
        navigate('/confirm-email');
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setMessage('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        {/* Header */}
        <h1 className="text-2xl font-bold text-center text-blue-800">Sign Up</h1>
        
        {/* Full Name Input */}
        <div className="mt-4">
          <input
            type="text"
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full px-4 py-2 mt-2 text-sm text-blue-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
        </div>

        {/* Email Input */}
        <div className="mt-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 mt-2 text-sm text-blue-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
        </div>

        {/* Password Input */}
        <div className="mt-4">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 mt-2 text-sm text-blue-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
        </div>

        {/* Sign Up Button */}
        <button
          onClick={handleSignUp}
          disabled={loading}
          className={`w-full flex items-center justify-center px-4 py-2 mt-4 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-yellow-400 ${
            loading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          {loading ? 'Signing Up...' : 'Sign Up'}
        </button>

        {/* Login Link */}
        <p className="mt-4 text-sm text-center text-blue-600">
          Already have an account?{' '}
          <Link to="/" className="text-yellow-500 hover:underline">
            Login
          </Link>
        </p>

        {/* Message */}
        {message && <p className="mt-4 text-sm text-center text-red-500">{message}</p>}
      </div>
    </div>
  );
};

export default SignUp;
